import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NewplaBaseComponent2, NewplaPageUtils } from '@newpla/ng-common';
import { Bs5ModalCtrl } from '@newpla/ng-lib';
import { NpTaskAll } from '@newpla/ts-common';
import { CollectionView, NpFlexGridCtrl } from '@newpla/wijmo';
import { NpxCommonModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-common.module';
import { NpxWijmoGridModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-wijmo-grid.module';
import { NpFilterUtils } from '@sls-nova/shared-admin/nova-admin-core/utils/np-filter-utils';
import { SlsNovaPageLoading } from '../../config/sls-nova-page-loading';

@Component({
  selector: 'app-simple-grid-result-modal',
  templateUrl: './simple-grid-result-modal.component.html',
  styleUrls: ['./simple-grid-result-modal.component.scss'],
  standalone: true,
  imports: [NpxCommonModule, FormsModule, NpxWijmoGridModule, DragDropModule]
})
export class SimpleGridResultModalComponent extends NewplaBaseComponent2 {

  modalCtrl = new Bs5ModalCtrl({ fullscreen: true });

  // ================================================================================================= BROWSER INIT

  override browserNgOnInit = () => {
    const taskAll = new NpTaskAll();
    taskAll.add(SlsNovaPageLoading.wait());
    /////
    taskAll.run().then(() => {
      this.flexGrid1Cv = new CollectionView(this.data);
      this.browserInited = true;
    }, NewplaPageUtils.browserInitError);
  };
  // 페이지 초기화 여부
  browserInited: boolean = false;
  // --------------------------------------------------------------------------------------

  titleIconClass!: string;
  title!: string;
  headers!: Array<any>;
  data: any;

  flexGrid1Cv: CollectionView = new CollectionView([]);
  flexGrid1Ctrl: NpFlexGridCtrl = new NpFlexGridCtrl();

  filterOpts = {
    params: { success: '' },
    doFilter: () => {
      this.flexGrid1Cv.filter = (item: any) => {
        if (!NpFilterUtils.defaultValidFilterFn(item.success, this.filterOpts.params.success)) return false;
        return true;
      }
    }

  }

}
